import { useMemo } from 'react';

import { useInstantSearch } from 'react-instantsearch';

type Result = ModelHookResult<{
	nOfFilters: number;
}>;

export function useAllFiltersMobileButton(): Result {
	const {
		indexUiState: { refinementList, toggle, range },
	} = useInstantSearch();

	const nOfCityStateFilter = refinementList?.['location.city_state']?.length || 0;
	const nOfCountryCodeFilter = refinementList?.['location.country_code']?.length || 0;

	const nOfFilters = useMemo(() => {
		let numberOfFilters = 0;
		// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
		if (refinementList?.tags?.length) {
			numberOfFilters += refinementList.tags.length;
		}
		if (toggle?.victory) {
			numberOfFilters += 1;
		}
		if (range?.weekly_signature_count) {
			numberOfFilters += 1;
		}

		numberOfFilters += nOfCityStateFilter;
		numberOfFilters += nOfCountryCodeFilter;

		return numberOfFilters;
	}, [nOfCityStateFilter, nOfCountryCodeFilter, refinementList, toggle, range]);

	return {
		data: {
			nOfFilters,
		},
	};
}
